module.exports = __webpack_public_path__ + "static/media/female.cb472613.svg";